module.exports = __webpack_public_path__ + "img/Phil Galfond.11517fe4.png";